import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SubcontractorsListPage } from './SubcontractorsListPage';
import { SubcontractorCreatePage } from './SubcontractorCreatePage';
import { SubcontractorDetailPage } from './SubcontractorDetailPage';
import { SubcontractorEditPage } from './SubcontractorEditPage';
import { FeatureGate } from '../../components/common/FeatureGate';

export const SubcontractorsApp: React.FC = () => {
  return (
    <FeatureGate
      requiredTiers={['pro', 'premium', 'enterprise']}
      featureName="Subcontractor Management"
      featureDescription="Efficiently manage your network of subcontractors, track their assignments, and monitor performance all in one place."
      benefits={[
        'Complete subcontractor database and profiles',
        'Track work assignments and schedules',
        'Monitor performance and quality metrics',
        'Manage payments and invoicing',
        'Store licenses and insurance documents',
        'Automated compliance tracking'
      ]}
    >
      <Routes>
        <Route path="/" element={<SubcontractorsListPage />} />
        <Route path="/new" element={<SubcontractorCreatePage />} />
        <Route path="/:id" element={<SubcontractorDetailPage />} />
        <Route path="/:id/edit" element={<SubcontractorEditPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </FeatureGate>
  );
};